import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import { exportToExcel } from "../../../common/CommonFunctions";
import MUITableSearch from "../../../components/MUITable/MUITableSearch";
import {
  getComparator,
  // descendingComparator,
  handleChangePage,
  handleChangeRowsPerPage,
  requestSearch,
  handleRequestSort,
  stableSort,
} from "../../../common/MuiTableFunctions.config";
import editIcon from "../../../assets/images/Edit.svg"
import AppCustomTooltip from "../../../components/CommonReusableComponent/AppCustomTooltip/AppCustomTooltip";
import Chip from "@mui/material/Chip";
import deleteIcon from "../../../assets/images/Delete.svg"

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: "grid",
  },
}));

const DepartmentMasterDataTable = ({
  RowData = [],
  Columns,
  RowsToDisplay,
  OptionsForRowsPerPage,
  HoverEffect,
  DenseTable,
  RequiredSearch,
  DataToBeExport,
  FileNameForExportData,
  HeaderFontSize,
  GetRowDataOnClickOfEditIcon,
  IsOutSideSearch,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(Columns[0].id);
  const [tableData, setTableData] = useState([...RowData]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(RowsToDisplay || 10);
  const [searchText, setSearchText] = useState("");

  // // To cancel the search value
  const cancelSearch = () => {
    setSearchText("");
    requestSearch(searchText, RowData);
    setTableData([...RowData]);
  };

  // To initiate search function
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    requestSearch(value, RowData);
  };

  // To trigger the function according to searchText
  useEffect(() => {
    if (searchText) {
      const filteredData = requestSearch(searchText, RowData);
      setTableData(filteredData);
      setPage(0);
    } else {
      setTableData([...RowData]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  // Whenever detect change set table data
  useEffect(() => {
    if (IsOutSideSearch && RowData) {
      setTableData(RowData);
      setPage(0);
    }
  }, [RowData, IsOutSideSearch]);

  return (
    <Paper sx={{ width: "100%", mb: 2, borderRadius: "5px" }}>
      {(RequiredSearch || DataToBeExport) && (
        <div
          className="d-flex align-items-center py-2 ps-2 pe-3"
          style={{
            background: "rgba(224, 224, 224, 0.4)",
            borderRadius: "5px 5px 0 0",
          }}
        >
          <div className="d-flex align-items-center gap-1">
            {RequiredSearch && (
              <MUITableSearch
                CancelSearch={cancelSearch}
                HandleSearch={handleSearch}
                SearchText={searchText}
              />
            )}
            {DataToBeExport && (
              <AppButton
                Type={"submit"}
                OnPress={() => {
                  exportToExcel(RowData, Columns, FileNameForExportData);
                }}
                Size={"small"}
                ClassName={"ms-2"}
                children={"Export"}
              />
            )}
          </div>
        </div>
      )}
      <TableContainer
        style={
          RequiredSearch || DataToBeExport
            ? {}
            : {
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }
        }
      >
        <Table
          size={DenseTable ? "small" : "medium"}
          className="rounded rounded-2"
        >
          <TableHead style={{ background: "rgba(224, 224, 224, 0.4)" }}>
            <TableRow>
              {Columns.map((column) => (
                <TableCell
                  key={column.id}
                  sortDirection={orderBy === column.id ? order : false}
                  style={{
                    cursor: "pointer",
                    padding: "auto",
                    fontSize: HeaderFontSize || "13px",
                  }}
                  align={column.headerAlign || "left"}
                >
                  {column.isSort ? (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() =>
                        handleRequestSort(
                          order,
                          orderBy,
                          column.id,
                          setOrder,
                          setOrderBy
                        )
                      }
                    >
                      <Typography
                        className="inter-medium-300"
                        variant="inherit"
                        noWrap={true}
                      >
                        {column.label}
                      </Typography>
                    </TableSortLabel>
                  ) : (
                    <Typography
                      className="inter-medium-300"
                      variant="inherit"
                      noWrap={true}
                    >
                      {column.label}
                    </Typography>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData && tableData[0] ? (
              stableSort(tableData, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow
                      hover={HoverEffect ? true : false}
                      role={"row"}
                      tabIndex={-1}
                      key={row.id}
                    >
                      {Columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.cellAlign || "left"}
                          sx={{ padding: "auto", width: column?.columnWidth }}
                        >
                          {column.isIcon && column.label === "Action" ? (
                            <div className="d-flex justify-content-center gap-3">
                              <img
                                src={editIcon}
                                className="cursor-pointer"
                                alt={"Edit"}
                                style={{ width: "22px", height: "22px" }}
                                onClick={() => {
                                  GetRowDataOnClickOfEditIcon(
                                    "Update Department",
                                    row
                                  );
                                }}
                              />
                              <img
                                src={deleteIcon}
                                className="cursor-pointer"
                                alt={"Edit"}
                                style={{ width: "22px", height: "22px" }}
                                onClick={() => {
                                  GetRowDataOnClickOfEditIcon(
                                    "Delete Department",
                                    row
                                  );
                                }}
                              />
                            </div>
                          ) : column.id === "departmentInchargeList" ? (
                            <CustomChipAndTooltip Data={row[column.id]} />
                          ) : (
                            <Typography
                              // noWrap={true}
                              className="inter-medium-300"
                              variant="inherit"
                            >
                              {row[column.id] || "Not Available"}
                            </Typography>
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })
            ) : (
              <TableRow hover={HoverEffect ? true : false} role={"row"}>
                <TableCell
                  align={"center"}
                  sx={{ padding: "auto" }}
                  colSpan={Columns?.length}
                >
                  <Typography
                    variant="subtitle2"
                    className="inter-regular-400 my-3"
                  >
                    There are no records to display
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={OptionsForRowsPerPage || [5, 10, 25]}
        component="div"
        className="custom-mui-pagination"
        slotProps={{
          select: {
            MenuProps: {
              MenuListProps: {
                classes: {
                  root: classes.menuItem,
                },
                sx: {
                  "& .MuiMenuItem-root": {
                    padding: "5px 8px",
                  },
                },
              },
            },
          },
        }}
        count={tableData && tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, page) => handleChangePage(event, page, setPage)}
        onRowsPerPageChange={(event) =>
          handleChangeRowsPerPage(event, setRowsPerPage, setPage)
        }
      />
    </Paper>
  );
};

const CustomChipAndTooltip = ({ Data }) => {
  const dataLength = Data && (Data?.length || 0)
  return (
    <div className="d-flex gap-2 align-items-center">
      <Typography noWrap={true} className="inter-medium-300" variant="inherit">
        {Data && Data[0] ? Data[0].departmentInchargeName : "Not Available"}
      </Typography>
      {dataLength > 1 ? (
        <AppCustomTooltip
          Placement="top"
          Title={Data.map((p) => p.departmentInchargeName).join(", ")}
        >
          <Chip
            label={`+${dataLength - 1} more`}
            size="small"
            style={{ cursor: "pointer" }}
          />
        </AppCustomTooltip>
      ) : null}
    </div>
  );
};

export default DepartmentMasterDataTable;
